import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

interface Props {
  count?: number;
  size?: 'small' | 'large';
}

export const FilterCount = ({ count, size = 'small' }: Props) => {
  if (!count) {
    return null;
  }

  const countText = count > 99 ? '99+' : count;
  return <Text css={[countStyle, size === 'small' ? smallStyle : largeSize]}>{countText}</Text>;
};

const countStyle = css({
  backgroundColor: theme.colors.primary10,
  color: theme.colors.primary70,
  padding: theme.spacing(0.25, 0.5),
  borderRadius: theme.borderRadius.small,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const smallStyle = css({
  minWidth: 16,
  height: 16,
  fontSize: theme.font.size.small,
});

const largeSize = css({
  minWidth: 24,
  height: 24,
  fontSize: theme.font.size.medium,
});
